import PropTypes from "prop-types";
import React from "react";

export const ToastMessageWithCta = ({
	className,
	onClick,
	cta,
	customButtonClassName,
	...rest
}) => {
	const buttonClass = customButtonClassName || "toast-cta";

	return (
		<div className={className || ""}>
			<ToastMessage {...rest} />
			<button className={buttonClass} onClick={onClick}>
				{cta}
			</button>
		</div>
	);
};

ToastMessageWithCta.propTypes = {
	className: PropTypes.string,
	cta: PropTypes.node.isRequired,
	onClick: PropTypes.func.isRequired,
	customButtonClassName: PropTypes.string
};

ToastMessageWithCta.defaultProps = {
	className: null,
	customButtonClassName: null
};

export const ToastTextMessage = ({ text }) => <p>{text}</p>;

ToastTextMessage.propTypes = {
	text: PropTypes.node.isRequired
};

export const ToastMessage = ({ text, title }) => (
	<>
		<b>{title}</b>
		<p>{text}</p>
	</>
);

ToastMessage.propTypes = {
	text: PropTypes.node.isRequired,
	title: PropTypes.node.isRequired
};
